import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { hasFeatureAccess, getBaseRouting } from '../../config/roleFeatures';

const ProtectedRoute = ({ children, requiredFeature }) => {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // If no feature requirement, allow access (for basic authenticated routes)
  if (!requiredFeature) {
    return children;
  }
  
  // Check if user has access to the required feature
  const userRole = user?.admin_role?.toUpperCase();
  const hasAccess = hasFeatureAccess(userRole, requiredFeature);
  
  // If no access, redirect based on user role
  if (!hasAccess) {
    return <Navigate to={getBaseRouting(userRole)} replace />;
  }
  
  return children;
};

export default ProtectedRoute;